const EmployeeCulture = () => {
  return (
    <div>
      <div className="bg-[#efefef] flex justify-center items-center h-[150px]">
        <h1 className="sm:text-[40px] text-[30px] font-bold">
          Employee Culture
        </h1>
      </div>

      <div className="lg:flex grid text-[#373737] my-[3rem] mx-[2rem]">
        <div className="max-w-[70rem] mx-auto flex flex-col md:flex-row justify-between ">
          <div className="flex-1 flex flex-col lg:px-[4rem]">
            <p className="react-reveal">
              Shaped by our core values, every employee and every team at TCS is
              clear about its targets and the incentives. Certain traditions,
              such as fairness, respect and looking for constant growth
              opportunities, actually promote the positive energies needed for
              an environment where ownership is promoted.
            </p>
            <p className="react-reveal mt-[.5rem]">
              The culture at TCS encourages its employees to help, support and
              celebrate each other’s success. We aspire to be more approachable
              and honest in our interactions with each other.
            </p>
          </div>

          <div className="flex gap-1 flex-1  lg:pr-[2rem] mt-[2rem] lg:mt-[0rem]">
            <div className="flex flex-col gap-1">
              <img
                src="/Home/employee-culture.jpg"
                alt=""
                className="lg:max-w-[30rem]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EmployeeCulture;
